


import Base from './Base';

export default class City extends Base {
  // 遵照这个接口定义的city结构
  // doc: https://doc.oschina.net/xingchengzushou?t=145627
  schema = {
    city: Number,
    day: Number,
    poi_uid: String,
    cn_name: String,
    en_name: String,
    lat: Number,
    lng: Number,
    pic: {
      full: String,
      big: String,
      small_s: String
    },

    is_customs: String,
    play_day: Number,
    // [{poi_uid: String, cn_name: String, en_name: String}]
    poi_list: Array,

    type: String,
    ascription_cn: String,
    ascription_en: String
  };

  // poi.getOne();
  static parseInput(obj) {
    return obj;
  }

  // city.getListByRegionId()
  static parseInput2(obj) {
    return {
      city: obj.city_id,
      cn_name: obj.cn_name,
      en_name: obj.en_name,
      is_customs: obj.is_customs,
      play_day: obj.play_day,
      lat: obj.lat,
      lng: obj.lng,
      pic: {
        full: obj.pic_url,
        big: obj.pic_url,
        small_s: obj.pic_url
      },
      poi_list: obj.poi_list
    };
  }

  // city.search()
  static parseInput3(obj) {
    return {
      city: obj.id,
      cn_name: obj.cn_name,
      en_name: obj.en_name,
      lat: obj.lat,
      lng: obj.lng,
      pic: {
        full: obj.pic_url,
        big: obj.pic_url,
        small_s: obj.pic_url
      },
      ascription_cn: obj.ascription_cn,
      ascription_en: obj.ascription_en,
      type: obj.type
    };
  }

  // city.assgin()
  static parseInput4(obj) {
    return {
      city: obj.city,
      day: obj.day,
      poi_uid: obj.poi_uid,
      cn_name: obj.cn_name,
      en_name: obj.en_name,
      is_customs: obj.is_customs,
      lat: obj.lat,
      lng: obj.lng,
      pic: obj.pic,
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/City.js